import Environment from "../environment";

import Api from "./ApiService";
import { AuthService } from "./AuthService";

import Factura from "../models/Factura";
import Unidad from "../models/Unidad";

export const FacturaService = {
    comprobantes: (uf, data) => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades-facturaciones/${uf}/comprobantes`,
                "GET",
                data
            )
                .then(data => {
                    data = data.map(item => new Factura(item));
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    imprimir: (uf, facturaId, periodo) => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades-facturaciones/${uf}/comprobantes/${encodeURIComponent(facturaId)}/imprimir${periodo ? `?periodo=${encodeURIComponent(periodo)}` : ""}`,
                "GET"
            )
                .then(data => {
                    data = data.map(item => new Factura(item));
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    adherirFD: uf => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades-facturaciones/${uf}/adherir`,
                "PUT",
                {}
            )
                .then(data => {
                    resolve(new Unidad(data));
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    bajaFD: (uf, data) => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades-facturaciones/${uf}/baja`,
                "PUT",
                data
            )
                .then(data => {
                    resolve(new Unidad(data));
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};
